import { IXAxisTickProps } from './types';

export const XAxisTick = ({ x, y, width, height, payload }: IXAxisTickProps) => {
  const dates = payload?.value.split(' ');
  const getText = (spacing: number, fill: string, className: string, text: string) => (
    <text
      width={width}
      height={height}
      x={x}
      y={(y ?? 0) + spacing}
      textAnchor="middle"
      fill={fill}
      className={className}
    >
      {text}
    </text>
  );

  const title = dates && getText(16, '#000000f0', 'typography-title-3', dates[0]);
  const subtitle = dates && getText(32, '#0000008a', 'typography-title-5', dates[1].toUpperCase());

  return (
    <>
      {title}
      {subtitle}
    </>
  );
};
